export const LOGIN_URL = '/login';
export const SSO_LOGIN_URL = '/sso/auth';
export const ADMIN_CONTRACTS_URL = '/admin/contracts';
export const ADMIN_CONTRACT_REPORTS_URL = '/admin/contracts/:id/reports';
export const ADMIN_CONTRACTS_SEARCH_URL = '/admin/contracts/search?search=';
export const ADMIN_CONTRACT_NEW_URL = '/admin/contracts/new';
export const ADMIN_CONTRACT_EDIT_URL = '/admin/contracts/:id';
export const ADMIN_CONTRACT_CONFIGURATION_URL = '/admin/contracts';
export const ADMIN_CONTRACT_REVIEW_URL = '/admin/contracts/:id/config';
export const NEW_LINE_ITEM_URL = '/admin/contracts/:id/lineitems/new';
export const EDIT_LINE_ITEM_URL = '/admin/contracts/:id/lineitems/:lineItemId';
export const NEW_AD_GROUP_URL = '/admin/contracts/:id/adgroups/new/:lineItemId';
export const EDIT_AD_GROUP_URL = '/admin/contracts/:id/adgroups/:adGroupId';
export const PIXEL_GENERATOR_URL = '/admin/pixelgenerator';
export const ALERTS_URL = '/admin/alerts';
export const PREVIEW_TOOL_URL = 'https://production-creative-preview.360platform.inmarket.com/';
export const CUSTOM_SEGMENTS_LIST_URL = '/admin/customsegments';
export const CUSTOM_SEGMENTS_NEW_URL = '/admin/customsegments/new';
export const CUSTOM_SEGMENTS_EDIT_URL = '/admin/customsegments/:id';
export const CLIENTS_LIST_URL = '/admin/clients';
export const CLIENTS_NEW_URL = '/admin/clients/new';
export const CLIENTS_EDIT_URL = '/admin/clients/:id';
export const CLIENTS_USERS_EDIT_URL = '/admin/clients/:id/users/:userId';
export const CLIENTS_USERS_NEW_URL = '/admin/clients/:id/users/new';
export const ADVERTISERS_EDIT_URL = '/admin/advertisers/:advertiserId';
export const CLIENTS_ADVERTISERS_EDIT_URL = '/admin/clients/:id/advertisers/:advertiserId';
export const CLIENTS_ADVERTISERS_NEW_URL = '/admin/clients/:id/advertisers/new';
export const ADVERTISERS_CREATIVES_ROOT_URL = '/admin/contracts/advertisers';
export const ADVERTISERS_CREATIVES_EDIT_URL = '/admin/contracts/advertisers/:advertiserId/creatives/:creativeId/*';
export const ADVERTISERS_CREATIVES_NEW_URL = '/admin/contracts/advertisers/:advertiserId/creatives/new/*';
export const PRODUCTS_ROOT_URL = '/admin/adgroups/:adGroupId/products';
export const PRODUCTS_NEW_URL = '/admin/adgroups/:adGroupId/products/new';
export const PRODUCTS_EDIT_URL = '/admin/adgroups/:adGroupId/products/:productId';
export const REPORTING_HUB_URL = '/admin/reporting';
export const REPORTING_HUB_NEW_URL = '/admin/reporting/new';
export const REPORTING_HUB_EDIT_URL = '/admin/reporting/:reportTemplateId';
export const REPORTING_HUB_EDIT_DEFAULT_URL = '/admin/reporting/default/:reportTemplateId';
export const SHARED_APP_LIST_URL = '/admin/sharedapplists';
export const SHARED_APP_LIST_NEW_URL = '/admin/sharedapplists/new';
export const SHARED_APP_LIST_EDIT_URL = '/admin/sharedapplists/:id';
export const PREVIEW_STUDIO_URL = '/preview';
export const PREVIEW_STUDIO_CAMPAIGN_URL = '/preview/campaign/:campaignId';
export const PREVIEW_STUDIO_CREATIVE_URL = '/preview/creative/:creativeId';
export const PREVIEW_GALLERY_URL = '/shared_gallery/:publicRoute';